// Pages du lot 2 pour le fil d'Ariane, le bouton retour et l'aide contextuelle (même forme que PAGES du lot 1).
// Fichier sans composant, importable par la table centrale des pages sans dépendance circulaire.

export const PAGES_STOCKS: { motif: RegExp; libelle: string; parent: string | null; aide: string }[] = [
  {
    motif: /^\/stocks$/,
    libelle: 'Stocks',
    parent: '/',
    aide: 'Ce qui demande une action est en tête : alertes élevées et critiques, installations avec anomalie ou déclaration en attente. Les réserves additionnent le volume brut mesuré des dépôts et le transit ; une donnée périmée est exclue du total et comptée à part. Une valeur absente est « indisponible » avec son motif.',
  },
  {
    motif: /^\/stocks\/installations\/[^/]+$/,
    libelle: 'Fiche de stock',
    parent: '/stocks',
    aide: 'Réservoirs (fond de cuve en pointillé, hachures pour une donnée ancienne), stock par produit et autonomie avec sa confiance, positions par propriétaire, mouvements, historique des jaugeages, anomalies et import. Une déclaration cohérente est acceptée à l’état « déclaré » ; une anomalie la laisse en attente de validation avec le détail des contrôles (D-012).',
  },
  {
    motif: /^\/approvisionnements$/,
    libelle: 'Approvisionnements',
    parent: '/',
    aide: 'Arrivages attendus à 7, 15, 30, 60 et 90 jours comparés aux besoins estimés (consommation moyenne observée tant que les prévisions ne sont pas construites). Un volume annoncé n’est jamais compté comme reçu. Toute modification de la programmation est tracée avec son motif.',
  },
  {
    motif: /^\/approvisionnements\/cargaisons\/[^/]+$/,
    libelle: 'Cargaison',
    parent: '/approvisionnements',
    aide: 'Cycle de statuts de la cargaison, report motivé, position saisie à la main avec son horodatage et son âge, fin de déchargement avec la quantité réceptionnée. Le connecteur AIS est décrit mais non raccordé : aucune position n’est simulée.',
  },
  {
    motif: /^\/gpl$/,
    libelle: 'GPL',
    parent: '/',
    aide: 'Le gaz s’additionne en kilogrammes : vrac des sphères et contenu nominal des bouteilles pleines. Les bouteilles vides ne portent aucun gaz.',
  },
  {
    motif: /^\/gpl\/[^/]+$/,
    libelle: 'Centre d’emplissage',
    parent: '/gpl',
    aide: 'Le remplissage diminue le vrac et transforme des bouteilles vides en pleines ; la livraison fait sortir des pleines et rentrer des vides.',
  },
  {
    motif: /^\/alertes$/,
    libelle: 'Alertes',
    parent: '/',
    aide: 'Quatre niveaux : informative, préventive, élevée, critique. Une alerte existante sur le même objet et le même déclencheur est mise à jour, jamais dupliquée ; une montée de niveau ferme l’alerte précédente en la liant. Les notifications internes sont listées à droite.',
  },
  {
    motif: /^\/alertes\/regles$/,
    libelle: 'Règles d’alerte',
    parent: '/alertes',
    aide: 'Seuils par niveau, délais de traitement avant escalade et destinataires par rôle. Chaque modification crée une nouvelle version avec son motif et son auteur.',
  },
  {
    motif: /^\/alertes\/[^/]+$/,
    libelle: 'Fiche d’alerte',
    parent: '/alertes',
    aide: 'Constat, mesure, règle appliquée, échéance de traitement et historique. Actions possibles : acquitter, affecter un responsable, consigner une action, résoudre avec motif, rouvrir.',
  },
];
